// client/src/features/properties/enums.ts — the portfolio's wire enums, as runtime lists · PROP-004.
//
// The generated client (`src/client/types.gen.ts`) gives each enum as a string-literal UNION —
// the shape 04 §4.8 asks for — and a union has no runtime value: a `<select>` cannot iterate
// it and `z.enum()` cannot validate against it. So each enum is spelled out once more here,
// and the spelling is HELD to the union: `Record<PropertyType, …>` is exhaustive in both
// directions, so a member the contract adds and this file lacks — or one this file keeps after
// the contract dropped it — is a compile error in the very PR that regenerated the client.
//
// Labels stay in `romanian.json` under `enums.{EnumName}.{VALUE}` (04 §9.6.3), the one computed
// key shape the i18n gate admits; a member added here without its label fails that gate.

import type { OccupancyStatus, PropertyHandoverStatus, PropertyType } from '@/client';

/** 03 §3.4's eight types, in the order the form and the filter offer them. */
const PROPERTY_TYPE_ORDER: Record<PropertyType, true> = {
  APARTMENT: true,
  STUDIO: true,
  HOUSE: true,
  ROOM: true,
  COMMERCIAL_SPACE: true,
  GARAGE_PARKING: true,
  LAND: true,
  OTHER: true,
};

export const PROPERTY_TYPES = Object.keys(PROPERTY_TYPE_ORDER) as readonly PropertyType[];

/**
 * Derived from the contracts in force (05 PROP-001), never stored, and since PROP-001 a real
 * enum on the wire — `Prop360.Domain.Portfolio.OccupancyStatus`, the three members this file
 * named ahead of it (D-363). `PARTIALLY_OCCUPIED` is PROP-003's: a property with units can
 * have some let and some free.
 */
const OCCUPANCY_STATUS_ORDER: Record<OccupancyStatus, true> = {
  VACANT: true,
  PARTIALLY_OCCUPIED: true,
  OCCUPIED: true,
};

export const OCCUPANCY_STATUSES = Object.keys(OCCUPANCY_STATUS_ORDER) as readonly OccupancyStatus[];

/**
 * The offer's three states (D-1771). PENDING is the only one the strip can act on; the other
 * two are terminal and the row stays as history.
 */
const PROPERTY_HANDOVER_STATUS_ORDER: Record<PropertyHandoverStatus, true> = {
  PENDING: true,
  ACCEPTED: true,
  REVOKED: true,
};

export const PROPERTY_HANDOVER_STATUSES = Object.keys(
  PROPERTY_HANDOVER_STATUS_ORDER,
) as readonly PropertyHandoverStatus[];
